import PageSimple from '@/components/PageSimple';

const PrivacyPage = () => <PageSimple title="Privacy Policy" path="/privacy" />;

export default PrivacyPage;
